import { useEffect, useRef } from "react";
function useAbortController(dependencies = []) {
  const abortControllerRef = useRef(null);
  useEffect(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    return () => {
      var _a;
      (_a = abortControllerRef.current) == null ? void 0 : _a.abort();
      abortControllerRef.current = null;
    };
  }, dependencies);
  return abortControllerRef.current || void 0;
}
export {
  useAbortController as default
};
